import { type Epic, combineEpics } from 'redux-observable';
import { filter, mergeMap } from 'rxjs';
import { request } from '@/core';
import { openSnackbar } from '@/core/features/snackbar';
import { updateUserRequest } from '@/api/user';
import i18n from '@/i18n';
import { updateUser, setUpdatedUser } from '../actions';

const updateUserEpic: Epic = (action$) =>
  action$.pipe(
    filter(updateUser.match),
    request(({ payload }) => updateUserRequest(payload), updateUser),
  );

const updateUserSucceededEpic: Epic = (action$) =>
  action$.pipe(
    filter(updateUser.succeeded.match),
    mergeMap(({ payload: { data: user } }) => [
      setUpdatedUser(user),
      openSnackbar({
        snackbarType: 'success',
        snackbarMessage: i18n.t('PROFILE_UPDATE_SUCCESS'),
      }),
    ]),
  );

export default combineEpics(updateUserEpic, updateUserSucceededEpic);
